import { render, staticRenderFns } from "./overtime_detail.vue?vue&type=template&id=92b96104"
import script from "./overtime_detail.vue?vue&type=script&lang=js"
export * from "./overtime_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports